import {ref, watch, computed} from '@vue/composition-api'
import store from '@/store'
import {useToast} from 'vue-toastification/composition'
import {toastMessage} from "@core/utils/utils";
import router from "@/router";
import {perPageOptions} from "@core/utils/filter";

export default function useList() {
    const toast = useToast()
    const refListTable = ref(null)

    const tableColumns = [
        {key: 'id', label: '#', sortable: false, thStyle: {width: "1%"}},
        {key: 'first_name', label: 'FIRST NAME', sortable: false},
        {key: 'last_name', label: 'LAST NAME', sortable: false},
        {key: 'email', label: 'EMAIL', sortable: false},
        {key: 'phone', label: 'PHONE', sortable: false},
        {key: 'is_academy', label: 'IS ACADEMY', sortable: false},
        {key: 'sports', label: 'SPORTS', sortable: false},
        {key: 'status', label: 'STATUS', sortable: false, thStyle: {width: "1%"}},
        {key: 'actions', label: 'ACTIONS', thStyle: {width: "2%"}},
    ]

    const busy = ref(false)
    const perPage = ref(10)
    const totalCount = ref(0)
    const currentPage = ref(1)
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const isVisible = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalCount.value,
        }
    })

    const reFetchData = () => {
        refListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        reFetchData()
    })

    const fetchList = (ctx, callback) => {
        busy.value = true
        store.dispatch('store/fetchDepartmentList', {
            universityId: router.currentRoute.params.id,
            queryParams: {
                search: searchQuery.value,
                start: currentPage.value,
                length: perPage.value,
                sortColumn: sortBy.value,
                sortDesc: isSortDirDesc.value,
            },
        }).then(response => {
            callback(response.data.data)
            totalCount.value = response.data.total_count
        }).catch(error => {
            if (error.response.status === 403) {
                isVisible.value = false
            } else {
                toastMessage(toast, 'danger', error.response.data.message)
            }
        }).finally(() => {
            busy.value = false
        })
    }

    return {
        tableColumns,
        perPage,
        currentPage,
        totalCount,
        dataMeta,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refListTable,
        busy,
        isVisible,

        perPageOptions,

        fetchList,
        reFetchData,
    }
}
